import React from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { GlobalDesignGroupActionPanel } from '../types';
import { useGlobalDesignStyles } from '../common/abstractStyles';
import { BorderControls } from './components/BorderControls';
import { ControlsServiceProvider } from '../../automaticPanel/panelsService/ControlsServiceContext';
import { GD_WDS_EXPERIMENT } from '../experiments';
import { useTranslation } from '../..';
import { GLOBAL_DESIGN_TRANSLATION_KEYS } from '../constants';
import { resolveEditorComponent } from '../resolveEditorComponent';
import { EditorSubType } from '@wix/editor-platform-sdk-types';

const ResolvedBorderControls = resolveEditorComponent({
  default: () => import('./components/BorderControlsWDS'),
  overrides: {
    [EditorSubType.Studio2]: () => import('./components/BorderControlsStudio2'),
  },
});

const BorderStyles: GlobalDesignGroupActionPanel = (props) => {
  const { experiments } = useExperiments({ readOnly: true });
  const [t] = useTranslation();
  const isWDS = experiments.enabled(GD_WDS_EXPERIMENT);

  const { values, updateStyles, isLoading, error, sdkClient } =
    useGlobalDesignStyles(props.host, 'borderStyles', props.componentsAPI, {
      shouldRefetchOnUpdate: false,
      withVariablesResolution: true,
    });

  if (isLoading || !values) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOADING)}</div>;
  }

  if (error) {
    return <div>{t(GLOBAL_DESIGN_TRANSLATION_KEYS.LOAD_ERROR)}</div>;
  }

  if (isWDS) {
    return (
      <ResolvedBorderControls
        metadata={props.group?.metadata}
        values={values}
        updateStyles={updateStyles}
        sdkClient={sdkClient}
      />
    );
  }

  return (
    <ControlsServiceProvider host={props.host}>
      <BorderControls
        metadata={props.group?.metadata}
        values={values}
        updateStyles={updateStyles}
        componentsAPI={props.componentsAPI}
        sdkClient={sdkClient}
      />
    </ControlsServiceProvider>
  );
};

export default BorderStyles;
